module.exports = __webpack_public_path__ + "assets/media/basketman.76ba69c4.svg";